<template>
    <div class="ls-one-time-mowing__container">
        <form @submit.prevent="submitOneTimeMowingForm()">
            <ls-panel
                class="ls-border-all ls-border-bottom-none ls-one-time-mowing__service-details"
            >
                <ls-manual-request :preselected-services="{ 'one-time': true, recurring: false }">
                    <a
                        :class="{
                            'ls-button': true,
                            'll-button-primary': isLawnLove || isHomeGnome,
                            'ls-button--yellow': isLawnStarter,
                        }"
                        style="width: 75px;"
                        @click.prevent="goBack()"
                    >
                        <i class="fa fa-arrow-circle-left"></i>
                        <span>&nbsp;Back</span>
                    </a>
                    <h2
                        class="ls-align--center ls-condensed section-title"
                        :class="{ 'ls-margin--bottom ls-margin--top': screenSize.xs }"
                    >
                        One-time Mowing Request
                    </h2>
                    <p class="ls-align--center" data-font-size="-1" style="margin-top: 3px;">
                        We handle one-time service requests on a case-by-case basis. Please fill out
                        the form, and someone will be in touch.
                    </p>
                    <hr />
                </ls-manual-request>
            </ls-panel>

            <ls-panel class="ls-border-all ls-border-top-none ls-one-time-mowing__contact-form">
                <ls-contact-info :title="'How can we get in touch with you?'"></ls-contact-info>
                <ls-error></ls-error>

                <div slot="button" class="grid">
                    <div class="grid__col-12 ls-margin--top">
                        <button
                            v-ls-track.click="{
                                target: 'one-time-mowing-form--submit-button',
                            }"
                            :class="{
                                'ls-button ls-button--block ls-button--lg ls-margin--top': true,
                                'll-button-primary': isLawnLove || isHomeGnome,
                                'ls-button--yellow': isLawnStarter,
                            }"
                            type="submit"
                        >
                            <span v-if="manualRequest.submitting"
                                ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Requesting Quote</span
                            >
                            <span v-else>Request Quote</span>
                        </button>
                    </div>
                </div>
            </ls-panel>
        </form>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import { mapState, mapGetters, mapActions } from 'vuex';
import * as types from '@/store/types';
import eventBusService from '@/services/event-bus.service';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import lsError from '@/components/original-mydot/error/Error.vue';
import lsManualRequest from '@/components/original-mydot/manual-request/ManualRequest.vue';
import lsContactInfo from '@/components/original-mydot/contact-info/ContactInfo.vue';
import brandMixin from '@/mixins/brand.mixin';

export default {
    components: {
        lsPanel,
        lsError,
        lsManualRequest,
        lsContactInfo,
    },
    mixins: [brandMixin],
    data() {
        return {};
    },
    computed: {
        ...mapState(['manualRequest', 'screenSize', 'contactInfo']),
        ...mapGetters({
            mobile: types.SCREEN_SIZE__GET_MOBILE_SCREEN,
        }),
        allStatesValid() {
            return this.manualRequest.valid && this.contactInfo.valid;
        },
    },
    methods: {
        ...mapActions({
            submitManualRequest: types.MANUAL_REQUEST__SUBMIT_MANUAL_REQUEST,
        }),
        submitOneTimeMowingForm() {
            if (!this.allStatesValid) {
                eventBusService.eventBus.$emit('submitButtonClick');
                setTimeout(() => {
                    const firstInvalidInput =
                        document.getElementsByClassName('ls-manual-request--mq-invalid')[0] ||
                        document.getElementsByClassName('ls-invalid')[0] ||
                        null;

                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
            } else {
                this.submitManualRequest(this.$route);
            }
        },
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.themed-lawnlove {
    .ls-one-time-mowing__service-details {
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
    }

    .ls-one-time-mowing__contact-form {
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
    }
}
</style>
